import { mapActions, mapGetters, mapMutations } from "vuex";
import orders from "./pages/orders/index.vue";
import addresses from "./pages/addresses/index.vue";
import changeNameForm from "./components/change-name-form/index.vue";
import info from "./pages/info/index.vue";
export default {
    name: "profile",
    data() {
        return {
            payload: {
                name: "",
                second_name: "",
                last_name: "",
                birthday: "",
                email: "",
                phone: "",
                password: "",
                new_password: "",
                new_password_confirmation: "",
            },
        };
    },
    components: {
        orders,
        addresses,
        changeNameForm,
        info,
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            isEditProfileData: "profile/editProfileData",
        }),
    },
    created() {
        // this.fetchUserData().then(() => {
        //     // console.log(this.user)
        // });
    },
    methods: {
        ...mapActions({
            logout: `auth/LOGOUT`,
            fetchUserData: `profile/FETCH_USER_DATA`,
            updateUserData: `profile/UPDATE_USER_DATA`,
            updateUserPassword: `profile/UPDATE_USER_PASSWORD`,
        }),
        ...mapMutations({
            changeEditProfileData: `profile/CHANGE_EDIT_PROFILE_DATA`,
        }),
        userLogout() {
            this.logout();
            this.$router.push({ name: "home" }).catch(() => {
                console.log();
            });
        },
        submit() {},
    },
};
